import { TApplicationState } from '../../types/redux';

export const selectFormMarketingAgreement = (state: TApplicationState) => state.agreements.marketingAgreement;
